import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPower = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9 1V9",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.13 3.5C3.25 4.81 2 6.99 2 9.46C2 13.46 5.13 16.71 9 16.71C12.87 16.71 16 13.46 16 9.46C16 6.99 14.75 4.81 12.87 3.5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		fill: "none"
	})]
});
export default SvgPower;
